<template>
    <div class="training">
        <div class="training__tiles">
            <training-tile
                v-for="assignment in assignments"
                :key="assignment.id"
                :assignment="assignment">
            </training-tile>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            assignments: [],
        };
    },

    methods: {
        fetch() {
            axios.get(this.route('tenantapi.trainings.index')).then(({data}) => {
                this.assignments = data.data;
            });
        },

        updateStatus() {
            setInterval(() => this.fetch(), 5000);
        }
    },

    mounted() {
        this.fetch();
        this.updateStatus();
    }
}
</script>
